import { render } from "./Declined.vue?vue&type=template&id=b8805fca"
import script from "./Declined.vue?vue&type=script&lang=js"
export * from "./Declined.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Declined.vue?vue&type=style&index=1&id=b8805fca&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__